<script lang="ts">
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import SectionTitle from "@kontextwerk/web-sdk/ui/typography/SectionTitle.svelte"
  import { openOverlay } from "@kontextwerk/web-sdk/core/overlay/globalStores"
  import type { HomeDashboardSectionState } from "../../../../../../../../../../api/kehrblatt/home-dashboard"
  import type { OrganizationOnboardingResponse } from "../../../../../../../../../../api/kehrblatt/organization-onboarding"
  import OnboardingDashboardCard from "./_modules/onboarding-dashboard-card"
  import OrganizationOnboardingOverlay from "./_modules/organization-onboarding-overlay"

  const {
    organizationId,
    organizationSlug = null,
    organizationName = null,
    currentUserId = null,
    onboarding,
    state,
    refreshing = false,
    canUseOperationalPlanning = false,
    onRetry,
    onUpdated,
    onRefreshRequested,
  } = $props<{
    organizationId: string
    organizationSlug?: string | null
    organizationName?: string | null
    currentUserId?: string | null
    onboarding: OrganizationOnboardingResponse | null
    state: HomeDashboardSectionState
    refreshing?: boolean
    canUseOperationalPlanning?: boolean
    onRetry: () => void
    onUpdated: (response: OrganizationOnboardingResponse) => void | Promise<void>
    onRefreshRequested: () => void
  }>()

  const handleOnboardingUpdated = (response: OrganizationOnboardingResponse) => {
    void onUpdated(response)
  }

  const openOnboardingOverlay = () => {
    if (!onboarding) return

    openOverlay({
      title: "KehrBlatt einrichten",
      content: OrganizationOnboardingOverlay,
      bodyPadding: "none",
      closeOnParentOpen: true,
      defaultFullscreen: true,
      onClose: onRefreshRequested,
      properties: {
        organizationId,
        organizationSlug,
        organizationName,
        currentUserId,
        initialOnboarding: onboarding,
        canUseOperationalPlanning,
        onUpdated: handleOnboardingUpdated,
      },
    })
  }
</script>

{#if state === "ERROR" || (state === "READY" && onboarding && !onboarding.completed)}
  <section class="onboarding-panel">
    <SectionTitle title="KehrBlatt einrichten" brightBackground={true} small={true} />
    {#if state === "ERROR"}
      <div class="state state--error">
        <span>Onboarding konnte nicht geladen werden.</span>
        <CTA
          type="secondaryButton"
          small={true}
          content="Erneut laden"
          darkMode={false}
          onClick={onRetry}
        />
      </div>
    {:else if onboarding}
      <OnboardingDashboardCard {onboarding} loading={refreshing} onOpen={openOnboardingOverlay} />
    {/if}
  </section>
{/if}

<style lang="less">
  .onboarding-panel {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    margin-bottom: 1.2rem;
  }

  .state {
    margin: 0;
    color: color-mix(in srgb, var(--text-invers-100) 72%, transparent);
    line-height: 1.45;
  }

  .state--error {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
    color: var(--error-color, #d34b4b);
  }
</style>
